export default __webpack_public_path__ + "static/161-e5712f3f9d67eb543fc3e92e8fa5a249.jpg";